import { render, staticRenderFns } from "./ComisionMedicos.vue?vue&type=template&id=28a1da6b&scoped=true&"
import script from "./ComisionMedicos.vue?vue&type=script&lang=js&"
export * from "./ComisionMedicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1da6b",
  null
  
)

export default component.exports